module.exports = "<div class=\"creditCardItemInlineCvv\">\r\n    <wow-loading-spinner ng-if=\"$ctrl.isLoading && !$ctrl.hasIframeFailed\" custom-spinner-class=\"creditCardItemInlineCvv-spinner\"></wow-loading-spinner>\r\n    <iframe\r\n        id=\"{{$ctrl.uniqueId}}\"\r\n        ng-show=\"$ctrl.hasLoaded\"\r\n        class=\"creditCardItemInlineCvv-iframe\"\r\n        scrolling=\"no\"\r\n        ng-src=\"{{$ctrl.iframeUrl}}\">\r\n    </iframe>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/digitalpay/creditcard/credit-card-item-inline-cvv.component.html
// module id = 927
// module chunks = 1